// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"announcement__wrap--3y_UX"};